import { useState, useEffect, createContext, useContext, useRef } from 'react';
import { LayoutSplashScreen } from '../../../../_vtsl/layout/core';
import Data from '../../../utils/SetGetData';
import * as authHelper from './AuthHelpers';
import { getUserByToken } from './_requests';

// Create authentication context with initial state
const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => { },
  currentUser: undefined,
  setCurrentUser: () => { },
  logout: () => {
    localStorage.removeItem('tanentLogin');
  },
};

const AuthContext = createContext(initAuthContextPropsState);

// Custom hook for accessing auth context
const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(authHelper.getAuth());
  const [currentUser, setCurrentUser] = useState();

  // Unified auth management function
  const saveAuth = (authData) => {
    setAuth(authData);
    authData ? authHelper.setAuth(authData) : authHelper.removeAuth();
  };

  // Complete logout handler
  const logout = () => {
    saveAuth(undefined);
    setCurrentUser(undefined);
    localStorage.clear(); // More efficient way to clear all storage
  };

  return (
    <AuthContext.Provider value={{ auth, saveAuth, currentUser, setCurrentUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const AuthInit = ({ children }) => {
  const { auth, logout, setCurrentUser } = useAuth();
  const didRequest = useRef(false);
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  // Get all required localStorage items at once
  const getStorageItems = () => ({
    extensionShowLogout: localStorage.getItem('ExtensionShowLogout'),
    currentExtension: localStorage.getItem('CurrentExtension'),
    extensionFirstName: localStorage.getItem('Extensionfirstname'),
    extensionLastName: localStorage.getItem('Extensionlastname'),
    extensionEmail: localStorage.getItem('ExtensionEmail'),
    extensionPortalExtensionId: localStorage.getItem('ExtensionPortalExtensionId'),
    userType: localStorage.getItem('user_type'),
    userResellerId: localStorage.getItem('userResellerId'),
    currentTId: localStorage.getItem('CurrentTId'),
    resellerName: localStorage.getItem('ResellerName'),
  });

  // Handle user data for admin/reseller case
  const handleAdminUser = async (apiToken) => {
    const { data } = await getUserByToken(apiToken);
    Data.setData('B_Token', data.token);
    console.log('data', data)

    return {
      admin: true,
      firstname: getStorageItems().resellerName,
      tenant_id: getStorageItems().currentTId || '',
      tenant_web_name: data.tenant_web_name,
      extension:data.extension,
      
    };
  };

  // Handle regular user data
  const handleRegularUser = async (apiToken) => {
    const { data } = await getUserByToken(apiToken);
    Data.setData('B_Token', data.token);
    return data;
  };

  // Process and set user information
  const processUserData = (data, storage) => {
    if (!data) return null;

    const updatedUserInfo = { ...data };

    // if (storage.currentTId) {
    //   console.log('storage1')
    //   updatedUserInfo.tenant_id = storage.currentTId;
    //   Data.setData('user_type', updatedUserInfo.user_type);
    // } else if (storage.extensionShowLogout) {
    //   console.log('storage2')

    //   Object.assign(updatedUserInfo, {
    //     extension: storage.currentExtension,
    //     email: storage.extensionEmail,
    //     firstname: storage.extensionFirstName,
    //     lastname: storage.extensionLastName,
    //     user_type: storage.userType,
    //   });
    // }

    if (storage.currentTId && storage.extensionShowLogout) {
      console.log('storage1 & storage2');

      updatedUserInfo.tenant_id = storage.currentTId;
      Data.setData('user_type', updatedUserInfo.user_type);

      Object.assign(updatedUserInfo, {
        extension: storage.currentExtension,
        email: storage.extensionEmail,
        firstname: storage.extensionFirstName,
        lastname: storage.extensionLastName,
        user_type: storage.userType,
        ...(storage.extensionPortalExtensionId
          ? { extension_id: storage.extensionPortalExtensionId }
          : {}),
      });

    } else if (storage.currentTId) {
      console.log('storage1');

      updatedUserInfo.tenant_id = storage.currentTId;
      Data.setData('user_type', updatedUserInfo.user_type);

    } else if (storage.extensionShowLogout) {
      console.log('storage2');

      Object.assign(updatedUserInfo, {
        extension: storage.currentExtension,
        email: storage.extensionEmail,
        firstname: storage.extensionFirstName,
        lastname: storage.extensionLastName,
        user_type: storage.userType,
        ...(storage.extensionPortalExtensionId
          ? { extension_id: storage.extensionPortalExtensionId }
          : {}),
      });
    }
    return updatedUserInfo;
  };

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const storage = getStorageItems();

        if (auth && !didRequest.current) {
          let userData;

          if (storage.userResellerId) {
            userData = await handleAdminUser(auth);
          } else {
            userData = await handleRegularUser(auth);
          }

          const processedUser = processUserData(userData, storage);
          if (processedUser) {
            setCurrentUser(processedUser);
            Data.setData('user_type', processedUser.user_type || 'admin');
          }
        }
      } catch (error) {
        console.error('Authentication initialization failed:', error);
        if (!didRequest.current) logout();
      } finally {
        setShowSplashScreen(false);
      }
    };

    if (auth) {
      initializeAuth();
    } else {
      logout();
      setShowSplashScreen(false);
    }

    return () => {
      didRequest.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>;
};

export { AuthProvider, AuthInit, useAuth };